
export type DeleteProject200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
